// src/pages/Login.jsx
import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthSplit from "../../components/AuthSplit";
import Support from "../../components/Support";

export default function LoginPage() {
  const { login, loginWithGoogle } = useAuth();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showPw, setShowPw] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();

    const { error } = await login(email, pw);

    if (error) {
      setErrorMsg(t("auth_page.invalid_credentials"));
      return;
    }

    window.location.href = "/";
  };

  return (
    <AuthSplit
      hero1={t("auth_split.hero1")}
      hero2={t("auth_split.hero2")}
      lead={t("auth_split.login_lead")}
      benefits
      title={t("login")}
      sub={t("auth_split.login_sub")}
      after={<Support />}
    >
      {errorMsg && <p className="auth-error-text">{errorMsg}</p>}

      <form onSubmit={onSubmit} className="auth-form">
        <div className="ca-field">
          <label className="ca-label" htmlFor="login-email">{t("email")}</label>
          <input
            id="login-email"
            className="auth-input"
            placeholder="example@email.com"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="ca-field">
          <label className="ca-label" htmlFor="login-pw">{t("password")}</label>
          <div className="password-wrapper">
            <input
              id="login-pw"
              className="auth-input"
              placeholder={t("auth_split.pw_placeholder")}
              type={showPw ? "text" : "password"}
              autoComplete="current-password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
            />

            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPw((p) => !p)}
              aria-label="비밀번호 보기"
            >
              {showPw ? (
                /* eye-off */
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 3l18 18" />
                  <path d="M10.58 10.58A3 3 0 0 0 12 15a3 3 0 0 0 1.42-.42" />
                  <path d="M9.88 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a18.6 18.6 0 0 1-3.17 4.57" />
                  <path d="M6.61 6.61A18.6 18.6 0 0 0 1 12s4 8 11 8a10.94 10.94 0 0 0 4.76-1.06" />
                </svg>
              ) : (
                /* eye */
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              )}
            </button>
          </div>
        </div>

        <div className="ca-forgot">
          <Link to="/forgot-password">{t("forgot_password")}</Link>
        </div>

        <button className="auth-btn" type="submit">
          {t("login")}
        </button>
      </form>

      <div className="auth-divider">
        <span>{t("auth_page.or")}</span>
      </div>

      <button
        type="button"
        className="google-login-btn"
        onClick={() => loginWithGoogle()}
      >
        <svg width="18" height="18" viewBox="0 0 48 48">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        {t("auth_split.google_continue")}
      </button>

      <div className="auth-links">
        <span>{t("auth_split.no_account")}</span>
        <Link to="/register">{t("register")}</Link>
      </div>
    </AuthSplit>
  );
}
